import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SignupStepperService } from '@app/modules/signup-new/services/signup-stepper.service';
import { SignupUserService } from '@app/modules/signup-new/services/signup-user.service';

@Component({
  selector: 'sbnb-signup-wizard',
  templateUrl: './signup-wizard.component.html',
  styleUrls: ['./signup-wizard.component.scss'],
})
export class SignupWizardComponent implements OnInit {
  constructor(
    public signupStepperService: SignupStepperService,
    private router: Router,
    private signupUserService: SignupUserService
  ) {}

  ngOnInit() {
    if (!this.signupUserService.user$.value) {
      this.router.navigate(['/signup']);
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  canDeactivate($event: BeforeUnloadEvent): string {
    const confirmationMessage =
      'Are you sure you want to leave this page? You will have to restart the signup process from the beginning.';

    // Standard way to prevent navigation and show a confirmation for most browsers
    $event.returnValue = confirmationMessage;

    // For some older browsers, the message must be returned as well
    return confirmationMessage;
  }
}
